import React, { createContext, useContext, useState } from 'react';

const SearchContext = createContext();

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearch deve ser usado dentro de um SearchProvider');
  }
  return context;
};

export const SearchProvider = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState(() => {
    // Recupera o termo de pesquisa do localStorage
    return localStorage.getItem('menuSearchTerm') || '';
  });

  const updateSearchTerm = (term) => {
    setSearchTerm(term);
    // Salva no localStorage
    localStorage.setItem('menuSearchTerm', term);
  };

  const clearSearch = () => {
    setSearchTerm('');
    // Remove do localStorage
    localStorage.removeItem('menuSearchTerm');
  };

  return (
    <SearchContext.Provider value={{ searchTerm, updateSearchTerm, clearSearch }}>
      {children}
    </SearchContext.Provider>
  );
}; 